import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import type { ImportData } from '@wix/extensions-data-client';
import { getDashboardPluginExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const DASHBOARD_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-plugin'
);

export async function generateDashboardPlugin(
  projectFolder: string,
  extended: string,
  route: string,
  title: string,
  importData?: ImportData
) {
  const cwd = getDashboardPluginExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'tsx',
    });

  const config = {
    id: randomUUID(),
    title,
    extends: extended,
    component: relativePathToCodeFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: DASHBOARD_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      config,
      importData,
    },
    importData,
  });
}
